import { useTranslation } from 'react-i18next';
import { Route, useHistory } from 'react-router-dom';

import { useFeature } from '@treams/treams-hooks';
import { AddIcon, HeartIcon, SendIcon } from '@treams/treams-icons';
import * as graphql from '@treams/treams-network';
import { Button, FlexGap, Popover } from '@treams/treams-ui';

import ComplimentRecipientSelector from './ComplimentRecipientSelector';

export default function ViewerFeedbackButtons() {
	const history = useHistory();
	const { t } = useTranslation();
	const hasCompliments = useFeature(graphql.FeatureName.Compliments);
	const canRequestFeedback = useFeature(graphql.FeatureName.FeedbackAdhoc);
	const canGiveFeedback = useFeature(graphql.FeatureName.FeedbackSpontaneous);

	return (
		<FlexGap gap={12} flexWrap="wrap">
			{canRequestFeedback && (
				<Button
					icon={<AddIcon />}
					title={t('feedback.index.new')}
					link="/feedback/request-from-moment"
				/>
			)}

			{canGiveFeedback && (
				<Button
					icon={<SendIcon />}
					title={t('feedback.index.send')}
					link="/feedback/send"
					type="secondary"
				/>
			)}

			{hasCompliments && (
				<Route path="/feedback/compliments/new">
					{({ match }) => (
						<Popover.Target
							center
							visible={!!match}
							contents={
								<ComplimentRecipientSelector
									onDismiss={() => history.push('/feedback/compliments')}
								/>
							}
							onDismiss={() => history.push('/feedback/compliments')}
						>
							<Button
								type="secondary"
								icon={<HeartIcon />}
								title={t('compliments.index.new')}
								link="/feedback/compliments/new"
							/>
						</Popover.Target>
					)}
				</Route>
			)}
		</FlexGap>
	);
}
